import { c as _c } from "react/compiler-runtime";
import { GraphQLPledge } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import beyondMeasureLogo from '../../images/pledge-beyond-measure.png';
import { CommitmentAvatar } from '../commitment-avatar/commitment-avatar.tsx';
export const PledgeIcon = t0 => {
  const $ = _c(2);
  const {
    pledgeName
  } = t0;
  switch (pledgeName) {
    case "Beyond Measure":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CommitmentAvatar responsive={true} imgSrc={beyondMeasureLogo} />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CommitmentAvatar responsive={true} />;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
  }
};